import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Necesito comprar suplementos caros?',
  answer: 'No. El protocolo se basa en alimentos reales y ajustes de estilo de vida accesibles en cualquier supermercado de USA.'
}, {
  question: '¿Es una dieta Keto?',
  answer: 'No. De hecho incluimos carbohidratos estratégicos para apoyar tu función tiroidea. Keto puede ser contraproducente después de los 40.'
}, {
  question: '¿Cuánto tiempo al día requiere?',
  answer: 'Menos de 15 minutos de ajustes específicos en tus rutinas actuales. No necesitas ir al gimnasio.'
}, {
  question: '¿Funciona si ya pasé la menopausia?',
  answer: 'Sí. Es ideal para equilibrar el cuerpo en post-menopausia. Los principios hormonales aplican en cualquier etapa.'
}, {
  question: '¿Cómo recibo el eBook después de comprar?',
  answer: 'Inmediatamente después de completar tu pago en Shopify, recibirás un email con el link de descarga directa del PDF. El proceso toma menos de 2 minutos. El archivo es compatible con cualquier dispositivo: iPhone, Android, tablet, laptop o computadora. No necesitas ninguna app especial — solo un lector de PDF.'
}, {
  question: '¿Qué pasa si siento que no es para mí?',
  answer: 'Tienes 30 días completos para revisarlo. Si por cualquier razón sientes que el protocolo no es lo que esperabas, escríbenos a nuestro email y te hacemos la devolución completa sin preguntas y sin complicaciones. Creemos tanto en este método que estamos dispuestas a asumir todo el riesgo por ti.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 lg:py-32 bg-white" data-id="element-17">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-19">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#2D5A34] text-center mb-12" data-id="element-20">
            Preguntas Frecuentes
          </h2>
          <div className="max-w-3xl mx-auto space-y-4" data-id="element-21">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.05
          }} className="bg-[#FDFAF6] rounded-xl overflow-hidden border border-gray-200" data-id="element-22">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-[#A8D5AC]/10 transition-colors" aria-expanded={openIndex === index} data-id="element-23">
                  <span className="text-lg font-semibold text-[#2D2D2D] pr-4" data-id="element-24">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-6 h-6 text-[#2D5A34] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-25" />
                </button>
                <AnimatePresence data-id="element-26">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-27">
                      <div className="px-6 pb-5" data-id="element-28">
                        <p className="text-[#2D2D2D] leading-relaxed" data-id="element-29">
                          {faq.answer}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}